import React from 'react';
import { Box } from '@mui/material';

const DataTable = () => {
  return <Box>DataTable</Box>;
};

export default DataTable;
